// extracted by mini-css-extract-plugin
export default {"buttonStayTime":"ButtonStayTime_buttonStayTime__FGK6F"};